<template>
  <router-link
    v-if="linkType !== 'custom'"
    :to="linkUrl"
    :class="classname"
    :target="target"
    :title="title"
    ref="link"
    :exact="exact"
  >
    <slot></slot>
  </router-link>

  <a
    v-else
    :href="linkUrl"
    :class="classname"
    :target="target"
    :title="title"
    ref="link"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "wp-link",
  props: ["url", "title", "classname", "target", "type", "id"],
  mounted: function() {
    //this.$emit('isActive', this.linkActive);
  },
  data() {
    return {
      homeUrl: window.WPVUE.home_url
    };
  },
  watch: {
    /* linkActive(val){
			this.$emit('isActive', val);
		} */
  },
  computed: {
    exact() {
      if (this.linkUrl === "/") return true;
      return false;
    },
    /* 		linkActive(){
			if(this.currentPageID && this.id){
				return this.currentPageID === this.id
			}else{
				return false;
			}
		}, */
    linkUrl() {
      if (this.url && this.url !== "") {
        return this.url.replace(this.homeUrl, "");
      } else return "";
    },
    linkType() {
      if (this.type) {
        return this.type;
      } else {
        if (!this.url || !this.url.includes(this.homeUrl)) {
          return "custom";
        }
      }
      return false;
    }
  },
  methods: {}
};
</script>
